import axios from 'axios';

import { GetAxiosAuthConfig } from '../mixins/axiosAuth'
    
export const InfiniteScroll = {
    mixins: [GetAxiosAuthConfig],
    data() {
        return {
            page_next_url: String,
            loading: false,
        }
    },
    mounted() {
        this.InfinteScroll()
    },
    methods: {
        GetNextPage() {
            // set loading to true to avoid multiple requests
            this.loading = true

            // get the rest url
            let resturl = this.page_next_url
            
            // don't attempt to get more if there isnt any
            if (resturl == null) {
                if (process.env.NODE_ENV == 'development') {
                    console.info("InfiniteScroll mixin: no more to load")
                }
                return
            }

            // to avoid CORs problem because the api generates :8000 URL
            if (process.env.NODE_ENV == 'development') {
                // resturl = resturl.replaceAll('8000', '8080')
                // console complains but it works
                resturl = resturl.replaceAll('http://localhost:8000', window.location.origin)
            }


            axios
                .get(resturl, axios_auth_config)
                .then(response => {
                    this.reviewables = this.reviewables.concat(response.data.results)
                    this.page_next_url = response.data.next
                    this.loading = false
                })
                .catch(error => console.log(error))
        },
        InfinteScroll() {

            // detects scrolling to the bottom of the browser and runs the GetNextPage function
            window.onscroll = () => {
                let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight > document.documentElement.offsetHeight -50 ;
                
                // only run if not already loading (doing a request) and at the bottom of the window
                if ((bottomOfWindow) && (this.loading == false)) {
                        this.GetNextPage()
                }
            }
        },
    },
}
